import axios from 'axios'

export default axios.create({
  baseURL: 'https://api.faywdz.com',
  timeout: 5000,
});